import {
  DepositMethods,
  UserWallets,
  DevType,
  BlockchainType,
} from "../typings";
import backendFunctions from "../config/url";

export default class {
  urlPrefix: string;
  mappedFunctions: {
    projectFetchCryptoDepositMethods: string;
    userFetchWalletAddresses: string;
    userFetchBalances: string;
    userGenerateNewAddress: string;
    userFetchNotifications: string;
  };

  constructor(urlPrefix: string) {
    this.urlPrefix = urlPrefix;
    this.mappedFunctions = backendFunctions(urlPrefix);
  }

  private fetch(url: string, data: any) {
    return fetch(url, {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => response.json());
  }

  projectFetchCryptoDepositMethods(
    publicKey: string,
    type: DevType
  ): Promise<DepositMethods> {
    return this.fetch(this.mappedFunctions.projectFetchCryptoDepositMethods, {
      publicKey,
      type,
    })
      .then((result) => result.data.depositMethods)
      .catch((err) => {
        console.error("projectFetchCryptoDepositMethods", err);
      });
  }

  userFetchWalletAddresses(
    publicKey: string,
    userId: string
  ): Promise<UserWallets> {
    return this.fetch(this.mappedFunctions.userFetchWalletAddresses, {
      publicKey,
      userId,
    })
      .then((result) => result.data.wallets)
      .catch((err) => {
        console.error("userFetchWalletAddresses", err);
      });
  }

  userFetchBalances(publicKey: string, userId: string, currency: "usd") {
    return this.fetch(this.mappedFunctions.userFetchBalances, {
      publicKey,
      userId,
      currency,
    })
      .then((result) => result.data)
      .catch((err) => {
        console.error("userFetchBalances", err);
      });
  }

  userGenerateNewAddress(
    publicKey: string,
    userId: string,
    blockchainType: BlockchainType
  ) {
    return this.fetch(this.mappedFunctions.userGenerateNewAddress, {
      publicKey,
      userId,
      blockchainType,
    })
      .then((result) => result.data)
      .catch((err) => {
        console.error("userGenerateNewAddress", err);
      });
  }

  userFetchNotifications(publicKey: string, userId: string) {
    return this.fetch(this.mappedFunctions.userFetchNotifications, {
      publicKey,
      userId,
    })
      .then((result) => result.data)
      .catch((err) => {
        console.error("userGenerateNewAddress", err);
      });
  }
}
